import {
  CharacterCounter,
  StringishInput,
  useSection,
  ValidationErrorMessage,
} from "@tree-company/tree-query";
import clsx from "clsx";
import t from "../locales";
import { useState } from "react";
import { MAX_CONSEQUENCES } from "../views/student_survey";

export function AddConsequenceSection({ content }) {
  const { key } = useSection(content);
  const [current, setCurrent] = useState(content.store.getAnswer(key));

  function handleClick(event) {
    event.preventDefault();
    setCurrent((v) => {
      const newCurrent = v + 1;
      content.store.setAnswer(key, newCurrent);
      return newCurrent;
    });
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="button button--outline"
      disabled={current >= MAX_CONSEQUENCES}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentcolor"
        className="icon button__icon"
      >
        <path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" />
      </svg>
      {t("consequence.add_more")}
    </button>
  );
}

export function ConsequenceQuestion({ question, className, handleChange }) {
  const { key, required, title, maxLength, hint, value } = useSection(question);

  function removeQuestion(event) {
    event.preventDefault();
    const [, baseKey, index] = key.match(/^(.+)_(\d\d?)$/);
    // Remove the current question
    question.store.setAnswer(key, null);
    // Move all the following questions one down (ie. q_6 -> q_5, q_7 -> q_6, ...)
    for (let i = parseInt(index); i < 20; i++) {
      const nextAnswer = question.store.getAnswer(`${baseKey}_${i + 1}`);
      question.store.setAnswer(`${baseKey}_${i}`, nextAnswer);
    }
    // Show one less consequence - this also triggers all these questions to re-render
    const amountKey = `${baseKey}_amount`;
    const currentAmount = question.store.getAnswer(amountKey);
    question.store.setAnswer(amountKey, currentAmount - 1);
  }

  return (
    <div
      className={clsx(
        "question question--string question--consequence",
        className,
      )}
    >
      <div className="question__label-wrapper">
        <label htmlFor={key} className="question__label">
          {title}
        </label>
        {!required && (
          <button
            type="button"
            className="question__remove"
            onClick={removeQuestion}
            aria-label={t("consequence.remove")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentcolor"
              className="icon icon--sm"
            >
              <path
                d="M4.26634 12.6663L3.33301 11.733L7.06634 7.99967L3.33301 4.26634L4.26634 3.33301L7.99967 7.06634L11.733 3.33301L12.6663 4.26634L8.93301 7.99967L12.6663 11.733L11.733 12.6663L7.99967 8.93301L4.26634 12.6663Z"
                fill="#1C1B1F"
              />
            </svg>
          </button>
        )}
      </div>
      <StringishInput question={question} onChange={handleChange} />
      {maxLength && (
        <CharacterCounter maxLength={maxLength} currentLength={value?.length} />
      )}
      {hint && <span className="question__hint">{hint}</span>}
      <ValidationErrorMessage question={question} className="question__error" />
    </div>
  );
}
